import { createContext, useContext } from "react";
// React Context to pass GA functions around
// See: https://reactjs.org/docs/context.html
export var GoogleAnalyticsContext = /*#__PURE__*/createContext({
  pageview: url => null,
  event: function (_event) {
    function event(_x) {
      return _event.apply(this, arguments);
    }

    event.toString = function () {
      return _event.toString();
    };

    return event;
  }(event => null)
});
export var useTracking = () => useContext(GoogleAnalyticsContext);
//# sourceMappingURL=context.js.map